// src/pages/About.jsx
import React from 'react';
import Seo from '../components/Seo';
import BreadcrumbJsonLd from '../components/BreadcrumbJsonLd';

import Hero from '../components/Home/Hero';
import TeamIntro from '../components/About/TeamIntro';
import MissionVision from '../components/About/MissionVision';
import Timeline from '../components/About/Timeline';
import TeamGallery from '../components/About/TeamGallery';
import AboutCTASection from '../components/About/AboutCTASection';

export default function AboutPage() {
  return (
    <>
      {/* SEO-meta voor deze pagina */}
      <Seo
        title="Over Ons | Online Growth Club"
        description="Leer meer over OnlineGrowthClub.nl: wie we zijn, wat we doen en waarom we het verschil maken in jouw online zichtbaarheid."
        path="/over-ons"
      />

      {/* Breadcrumb structured data */}
      <BreadcrumbJsonLd
        list={[
          { name: 'Home',    item: 'https://onlinegrowthclub.nl/' },
          { name: 'Over Ons', item: 'https://onlinegrowthclub.nl/over-ons' }
        ]}
      />

      {/* Pagina-secties */}
      <Hero />
      <TeamIntro />
      {/* <MissionVision /> */}
      {/* <Timeline /> */}
      <TeamGallery />
      <AboutCTASection />
    </>
  );
}
